export enum Vertical {
    SKIN = 'Skin',
    WEIGHT_LOSS = 'Weight loss',
}

type VerticalByParam = {
    [key: string]: Vertical | undefined;
};

export const verticalByParam: VerticalByParam = {
    skin: Vertical.SKIN,
    'weight-loss': Vertical.WEIGHT_LOSS,
};
